import { Box, Card, CardContent, Grid, Paper, Tooltip, Typography } from "@mui/material";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import { useAppSelector } from "../../app/store/configureStore";
import cpdCategoriesFormModel from "../pcsCpd/common/cpdCategoriesFormModel";
import { GetSummaryColorCode } from "../../app/utils/util";
import InfoIcon from '@mui/icons-material/Info';

interface Props {
    sixYearSummaryData: SummaryDto[][] | null;
    isYearPartialyCompleted: boolean;
    totalOfSummary: number[];
}

export default function SummaryTableMobileView({ sixYearSummaryData, isYearPartialyCompleted, totalOfSummary }: Props) {
    const {
        formField: {
            AccreditedCeActivity,
            ProfessionalDevelopmentPlan,
            PracticeReview,
            WorkbasedLearning,
            Total,
            OnTarget
        }
    } = cpdCategoriesFormModel;

    const { summaryTitles } = useAppSelector(state => state.pcs);

    const appInformationText = (information_text: string) => (
        <>
            {information_text && information_text !== ''
                && information_text !== null &&
                <Tooltip title={information_text} placement={"bottom"} arrow enterTouchDelay={0}>
                    <InfoIcon style={{ fontSize: '25px', margin: '0px', alignSelf: 'end' }} />
                </Tooltip>}
        </>
    );

    return <>
        {sixYearSummaryData?.map((item: SummaryDto[], index: number) => (
            <Card variant="outlined" key={index}>
                <Box component={Paper} sx={{ border: "1px solid #e0e0e0", p: 1, mt: 1 }} key={index}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="span">
                            <b>{item[0].text}</b>
                        </Typography>

                        <hr></hr>

                        <Grid container spacing={2} alignItems="center">

                            <Grid size={{ xs: 12 }}></Grid>

                            <Grid size={{ xs: 6 }} sx={{ display: "flex", alignItems: "center" }}>
                                <b>{summaryTitles === null ? '' : summaryTitles[3]}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(AccreditedCeActivity.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ backgroundColor: GetSummaryColorCode(item[3].status.toUpperCase()), textAlign: 'center', padding: 1 }}>
                                <b>{item[3].text.split('(')[0]}</b>({item[3].text.split('(')[1]}
                            </Grid>


                            <Grid size={{ xs: 6 }}>
                                <b>{summaryTitles === null ? '' : summaryTitles[4]}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(ProfessionalDevelopmentPlan.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ backgroundColor: GetSummaryColorCode(item[4].status.toUpperCase()), textAlign: 'center', padding: 1 }}>
                                <b>{item[4].text.split('(')[0]}</b>({item[4].text.split('(')[1]}
                            </Grid>


                            <Grid size={{ xs: 6 }}>
                                <b>{summaryTitles === null ? '' : summaryTitles[5]}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(PracticeReview.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ backgroundColor: GetSummaryColorCode(item[5].status.toUpperCase()), textAlign: 'center', padding: 1 }}>
                                <b>{item[5].text.split('(')[0]}</b>({item[5].text.split('(')[1]}
                            </Grid>


                            <Grid size={{ xs: 6 }}>
                                <b>{summaryTitles === null ? '' : summaryTitles[6]}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(WorkbasedLearning.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ backgroundColor: GetSummaryColorCode(item[6].status.toUpperCase()), textAlign: 'center', padding: 1 }}>
                                <b>{item[6].text.split('(')[0]}</b>({item[6].text.split('(')[1]}
                            </Grid>


                            <Grid size={{ xs: 6 }}>
                                <b>{Total.label}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(Total.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ textAlign: 'center', padding: 1 }}>
                                <b>{totalOfSummary[index]}</b>
                            </Grid>


                            <Grid size={{ xs: 6 }}>
                                <b>{summaryTitles === null ? '' : summaryTitles[7]}</b>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                {appInformationText(OnTarget.informationText)}
                            </Grid>

                            <Grid size={{ xs: 4 }} sx={{ backgroundColor: GetSummaryColorCode(item[7].status.toUpperCase()), textAlign: 'center', padding: 1 }}>
                                <b>{item[7].text}</b>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>
                <br></br>
            </Card>
        ))}

        {sixYearSummaryData?.length === 0 &&
            <Grid size={{ xs: 12 }} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
        }

        {isYearPartialyCompleted === true &&
            <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>*Partial Year Completed.</Grid>
        }

        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            Note: CPD Category requirements are displayed in brackets.
        </Grid>
    </>
}